import React from 'react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { FormButtons } from '../FormButtons';
import { ColorSelector } from '../ColorSelector';
export const SchuifwandColorStep: React.FC = () => {
  const {
    formData,
    handleOptionSelect,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Kleur schuifwand" description="Kies de kleur die het beste bij uw woning past." isActive={true} data-id="element-1123">
      <ColorSelector selectedColor={formData.schuifwandColor} onSelect={color => handleOptionSelect('schuifwandColor', color)} data-id="element-1124" />
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.schuifwandColor} data-id="element-1125" />
    </FormStep>;
};